import { useSearchParams } from "react-router-dom";

function useLanguageParam() {
   const params = useSearchParams()[0];
   const lang = params.get("lang");
   return lang;
}

export default useLanguageParam;
